export const SINGLE_ACCOUNT_SIGNAL_OUTBOUND_COLOR = 'brand.dustyOrange';
export const SINGLE_ACCOUNT_SIGNAL_INBOUND_COLOR = 'brand.klarityBlue';
